
<mat-form-field *ngIf="users !== undefined" class="full-width">
  <mat-label>{{libelle}}</mat-label>
    <input type= "text"
    matInput
    [required]="required"
    placeholder="Sélectionner le {{libelle.toLocaleLowerCase()}}"
    (change)="$event.target.value === '' ? deleteIfEmptyOrNotFound(): null"
    [formControl]="myControl"
    [matAutocomplete]="auto">
  <mat-autocomplete autoActiveFirstOption
   #auto="matAutocomplete"
    (optionSelected)="intervenantChange($event.option.value)"  >
  <mat-option *ngFor="let usr of filteredRealisateur | async" [value]="usr">
     {{usr}}</mat-option>
  </mat-autocomplete>

</mat-form-field>

